import Repository from "@/api/repository";
export default {
    getObjectCountFromUrl(url, config) {
        return Repository.get(url, config);
    }
};
